module.exports = __webpack_public_path__ + "static/dav_consulting-2824ea09185655c47efee205f973170a.svg";